// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__11BbJ","footer-links":"footer_footer-links__3vh2M","link":"footer_link__3nDrj","copyright":"footer_copyright__1nbcB"};